import { axiosService } from "./axiosService";

const sushiApi = {
    getAllSushi(params = {}) {
        const url = '/sushi';
        return axiosService.get(url, { params })
    },
    createSushi(body) {
        const url = '/sushi';
        return axiosService.post(url, body)
    },
    getAllSushi2(params = {}) {
        const url = '/sushi2';
        return axiosService.get(url, { params })
    },
    createSushi2(body) {
        const url = '/sushi2';
        return axiosService.post(url, body)
    },
    getBoxOrder(params = {}) {
        const url = '/box-order';
        return axiosService.get(url, { params })
    },
    syncOrderBox(body) {
        const url = '/sync-order-box';
        return axiosService.get(url, body)
    },
    syncSushi() {
        const url = '/sync-sushi';
        return axiosService.get(url)
    }
}

export default sushiApi;